
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
// This is Private Key   
    stripeKey: 'pk_live_51OdukELiZ6rQWdoXcyrXzd2Ygt3WofgPeLsxexosSZSONYHFHv240YvCUCBz4VENWG4iA78g36F3Vghmk0cZTfsj00H5eoyI7k',
    apiUrl: 'https://api.worx24.co.uk/Worx24Api/CCMemberService.svc',
    OrganisationID : 17,
    PaymentTypeID :3,
    ProductID:1,

    
  };
  
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
  